import {EventBus} from "@/main";
import {EventBusKey} from "@/constant/Constants";

export const HandleScroll = {
    data() {
        return{
            scrollIng:false,
            appContentScroll: 0,
            scrollUp:false,
            //scrollToTop
            height: 0,

        }
    },
    computed: {

    },
    created() {
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll, true)
        EventBus.$on(EventBusKey.scroll, ({width, height}) => {
            console.log('width,height',width,height)
        })
    },
    beforeDestroy() {
        EventBus.$off(EventBusKey.scroll);
        window.removeEventListener('scroll',this.handleScroll)
    },
    destroyed() {
    },
    methods: {
        handleScroll($event) {
            if ($event.target.id === 'app-content') {
                if ($event.target.scrollTop > this.appContentScroll) {
                    this.scrollUp=false
                }else if ($event.target.scrollTop < this.appContentScroll) {
                    this.scrollUp = true;
                }
                this.appContentScroll = $event.target.scrollTop;

                this.scrollIng = true;
            }
        },
    },
    filters:{

    },watch:{
        appContentScroll(newVal, oldVal) {
            setTimeout(() => {
                if (newVal === window.document.getElementById("app-content").scrollTop) {
                    this.scrollIng = false;
                }
            }, 1500);
        },
    }
}
